import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  width: '100%',
  gap: '4px 24px',
  paddingTop: '24px',
});
